// All page content lives here: edit copy, swap images, add pieces.
import logo from "./assets/brand/logo.png";

import fighter from "./assets/digital/crests/fighter.jpg";
import wizard from "./assets/digital/crests/wizard.jpg";
import ranger from "./assets/digital/crests/ranger.jpg";
import warlock from "./assets/digital/crests/warlock.jpg";
import bard from "./assets/digital/crests/bard.jpg";
import druid from "./assets/digital/crests/druid.jpg";
import rogue from "./assets/digital/crests/rogue.jpg";
import paladin from "./assets/digital/crests/paladin.jpg";
import cleric from "./assets/digital/crests/cleric.jpg";
import barbarian from "./assets/digital/crests/barbarian.jpg";
import warlockBanner from "./assets/digital/crests/warlock-banner.jpg";
import rollFor from "./assets/digital/designs/roll-for-d20.jpg";

import pouchPurple from "./assets/handcraft/leather/pouch-purple-scales.jpg";
import pouchGold from "./assets/handcraft/leather/pouch-gold-scales.jpg";
import pouchTeal from "./assets/handcraft/leather/pouch-teal-scales.jpg";
import pouchBrown from "./assets/handcraft/leather/pouch-brown-bronze-scales.jpg";
import trayTeal from "./assets/handcraft/leather/tray-teal.jpg";
import necklaceFront from "./assets/handcraft/chainmail/necklace-front-2.jpg";
import necklaceBack from "./assets/handcraft/chainmail/necklace-back-1.jpg";
import diceBag from "./assets/handcraft/chainmail/dice-bag-open.jpg";
import diceCandle from "./assets/handcraft/candles/dice-candle.jpg";

export const INSTAGRAM_URL = "https://www.instagram.com/miss_stabbypants/";
export const INSTAGRAM_HANDLE = "@miss_stabbypants";
export const CTA_LABEL = "Commission a piece";

// width/height set the frame; the image is centre-cropped to fit it.
export type Piece = {
  title: string;
  medium: string;
  src: string;
  width: number;
  height: number;
};

const crest = (title: string, src: string): Piece => ({
  title,
  medium: "Digital illustration",
  src,
  width: 1080,
  height: 1080,
});

// 625px round mark with a transparent background, cut from the festival exhibitor graphic.
export const LOGO = logo;

export const heroImage: Piece = { title: "Miss Stabbypants logo", medium: "Logo", src: logo, width: 625, height: 625 };

export const inlineImage = warlockBanner;

export const digitalWorks: Piece[] = [
  crest("The Fighter", fighter),
  crest("The Wizard", wizard),
  crest("The Ranger", ranger),
  crest("The Warlock", warlock),
  crest("The Bard", bard),
  crest("The Druid", druid),
  crest("The Rogue", rogue),
  crest("The Paladin", paladin),
  crest("The Cleric", cleric),
  crest("The Barbarian", barbarian),
  { title: "Roll For", medium: "Digital design", src: rollFor, width: 1080, height: 1080 },
];

// Laid out in two staggered columns: even items left, odd items right.
export const handcraftWorks: Piece[] = [
  { title: "Scale flap pouch, violet", medium: "Leather", src: pouchPurple, width: 1080, height: 1080 },
  // The necklace photos are letterboxed, so the frame crops to the picture.
  { title: "Chainmail necklace", medium: "Chainmail", src: necklaceFront, width: 1080, height: 720 },
  { title: "Dice tray", medium: "Leather", src: trayTeal, width: 1080, height: 1080 },
  { title: "Scale flap pouch, teal", medium: "Leather", src: pouchTeal, width: 1080, height: 1080 },
  { title: "Sword back drop", medium: "Chainmail", src: necklaceBack, width: 1080, height: 720 },
  { title: "Dice candle", medium: "Wax", src: diceCandle, width: 1080, height: 1350 },
  { title: "Scale flap pouch, gold", medium: "Leather", src: pouchGold, width: 1080, height: 1080 },
  { title: "Chainmail dice bag", medium: "Chainmail", src: diceBag, width: 1080, height: 1080 },
  { title: "Scale flap pouch, bronze", medium: "Leather", src: pouchBrown, width: 1080, height: 1080 },
];

// Set to null once the event is over and the band disappears.
export const event: { name: string; dates: string; venue: string; stand: string } | null = {
  name: "Fantasy Festival 2K26",
  dates: "2, 3 and 4 October 2026",
  venue: "Peristeri Exhibition Center",
  stand: "Hall C, stand C207",
};

export const manifesto =
  "Miss Stabbypants draws in pixels and builds by hand. Crests for every class at the table, dice pouches in leather and scale, chainmail to wear. Nothing mass produced. Everything a little sharp.";

export const marqueeWords = ["Class crests", "Leatherwork", "Chainmail", "Dice candles"];

export const process = [
  {
    step: "Message",
    body: "Send a DM on Instagram with your idea, any references, and whether you want it digital or handmade.",
  },
  {
    step: "Sketch",
    body: "You get a rough direction to react to before anything is final.",
  },
  {
    step: "Make",
    body: "The piece is finished on screen or built by hand, then it is yours.",
  },
];
